module.exports = __webpack_public_path__ + "resources/img/img_db-i_cloud01-en.115bd12c059b6fdc121dd14b40f3a646.png";